import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack justify-content-between gap-5 mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Gestión de Módulos", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-2 me-2 text-white" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "list-group"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "d-flex gap-4 align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-pencil fs-2 text-hover-primary cursor-pointer",
  title: "Editar módulo"
}, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "border-top bg-light" }
const _hoisted_12 = {
  key: 0,
  class: "p-4 text-center text-muted"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "p-4 text-center text-muted"
}
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = {
  key: 2,
  class: "list-group list-group-flush"
}
const _hoisted_17 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_18 = { class: "fw-semibold" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "d-flex gap-3" }

import { onMounted, ref } from 'vue';
import { Module, Submenu } from '@/core/interfaces/module.interface';
import { useProgress } from '@marcoschulte/vue3-progress';
import GlobalService from '@/core/services/GlobalService';
import { errManager, confirmDelete } from '@/core/config/Tools';
import { useI18n } from "vue-i18n/index";

//componentes
import AddEditModuleDrawer from './drawers/AddEditModuleDrawer.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleIndex',
  setup(__props) {

const { t } = useI18n();
const loader = ref(false);
const listModule = ref<Module[]>([]);
const dialogSubmenu = ref(false);
const savingSubmenu = ref(false);
const selectedModule = ref<Module | null>(null);

const getListModule = () => {
    const progress = useProgress().start()

    loader.value = true;
    GlobalService.get('api', 'modules')
        .then((res) => {
            loader.value = false;
            listModule.value = res.data.map((item: Module) => ({
                ...item,
                isOpen: false,
                loadingSubmenu: false,
                submenuLoaded: false,
                submenus: [],
            }));
            progress.finish();
        }).catch(({ response }) => {
            progress.finish()
            loader.value = false;
            errManager(response);
        }).finally(() => {
            progress.finish();
            loader.value = false;
        });
}


const registerModule = () => {

};

const editModule = (item: Module) => {
    console.log('Editar módulo', item)
}

const deleteModule = (item: Module) => {
    confirmDelete({
        module: 'modules',
        id: item.idmodule,
        name: item.module,
        t,
        onSuccess: getListModule,
        payload: { mstatus: 0 }
    });
    console.log('Eliminar módulo', item)
}

const sortModule = (item: Module) => {
    console.log('Ordenar módulo', item)
}

const openCreateSubmenu = (item: Module) => {

};

const toggleModule = async (item: Module) => {
    item.isOpen = !item.isOpen;

    listModule.value.forEach((module) => {
        if (module.idmodule !== item.idmodule) {
            module.isOpen = false
        }
    });

    if (item.isOpen && !item.submenuLoaded) {
        await getSubmenusByModule(item)
    }
};

const getSubmenusByModule = async (item: Module, reload = false) => {
    if (item.submenuLoaded && !reload) return;

    const progress = useProgress().start();

    try {
        item.loadingSubmenu = true
        const res = await GlobalService.get('api', `modules/${item.idmodule}/submenu`)

        item.submenus = res.data
        item.submenuLoaded = true
    } catch (error: any) {
        errManager(error.response ?? error)
    } finally {
        item.loadingSubmenu = false
        progress.finish()
    }
};

onMounted(() => {
    getListModule();
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: registerModule,
        class: "w-100 w-md-auto w-lg-auto"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_unref(t)('register')), 1)
        ]),
        _: 1
      })
    ]),
    (listModule.value.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listModule.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `lst-module-${index}`,
              class: "list-group-item list-group-item-action"
            }, [
              _createElementVNode("div", {
                class: "d-flex flex-row justify-content-between align-items-center list-group-item-action p-4 cursor-pointer",
                "aria-current": "true",
                onClick: ($event: any) => (toggleModule(item))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item?.icon)
                  }, null, 2),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item?.module), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi fs-3 text-muted", item.isOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
                  }, null, 2),
                  _hoisted_9,
                  _createElementVNode("i", {
                    class: "bi bi-trash fs-2 text-hover-danger cursor-pointer",
                    title: "Eliminar módulo",
                    onClick: _withModifiers(($event: any) => (deleteModule(item)), ["stop"])
                  }, null, 8, _hoisted_10)
                ])
              ], 8, _hoisted_5),
              _createVNode(_Transition, { name: "accordion" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_11, [
                    (item.loadingSubmenu)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _createTextVNode(" Cargando submenús... ")
                        ]))
                      : (!item.submenus || item.submenus.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createTextVNode(" No hay submenús registrados. "),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "small",
                                onClick: _withModifiers(($event: any) => (openCreateSubmenu(item)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Agregar submenú ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.submenus, (submenu, subIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `lst-submenu-${index}-${subIndex}`,
                                class: "list-group-item d-flex justify-content-between align-items-center ps-5 pe-4 py-3"
                              }, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(submenu.icon || 'bi bi-circle')
                                  }, null, 2),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(submenu.submenu), 1),
                                    _createElementVNode("small", _hoisted_19, _toDisplayString(submenu.route), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("i", {
                                    class: "bi bi-pencil fs-4 text-hover-primary cursor-pointer",
                                    title: "Editar submenú",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(()=> {}, ["stop"]))
                                  }),
                                  _createElementVNode("i", {
                                    class: "bi bi-trash fs-4 text-hover-danger cursor-pointer",
                                    title: "Eliminar submenú",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(()=> {}, ["stop"]))
                                  })
                                ])
                              ]))
                            }), 128))
                          ]))
                  ], 512), [
                    [_vShow, item.isOpen]
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón registros"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: getListModule
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('tryAgain')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loader.value]
        ]),
    _createVNode(AddEditModuleDrawer)
  ], 64))
}
}

})